import React from 'react'
import { IconProps } from '../../../common/types'

const Calendar: React.FC<IconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5em"
      height="5em"
      viewBox="0 0 48 48"
    >
      <path
        fill="#45413c"
        d="M6.41 44.35a17.59 1.65 0 1 0 35.18 0a17.59 1.65 0 1 0-35.18 0"
        opacity="0.15"
      />
      <path
        fill="#bdbec0"
        stroke="#45413c"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.61 35.8h30.78v4.4a3.3 3.3 0 0 1-3.3 3.3H11.91a3.3 3.3 0 0 1-3.3-3.3z"
        strokeWidth="1"
      />
      <path
        fill="#bdbec0"
        stroke="#45413c"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.61 33.6h30.78V38a3.3 3.3 0 0 1-3.3 3.3H11.91a3.3 3.3 0 0 1-3.3-3.3z"
        strokeWidth="1"
      />
      <path
        fill="#fff"
        stroke="#45413c"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.61 16h30.78v19.8a3.3 3.3 0 0 1-3.3 3.3H11.91a3.3 3.3 0 0 1-3.3-3.3z"
        strokeWidth="1"
      />
      <path
        fill="#ff6242"
        d="M11.91 6.67h24.18a3.3 3.3 0 0 1 3.3 3.3v6H8.61V10a3.3 3.3 0 0 1 3.3-3.33"
      />
      <path
        fill="#ff866e"
        d="M36.09 6.67H11.91A3.29 3.29 0 0 0 8.61 10v2.75a3.29 3.29 0 0 1 3.3-3.3h24.18a3.29 3.29 0 0 1 3.3 3.3V10a3.29 3.29 0 0 0-3.3-3.33"
      />
      <path
        fill="none"
        stroke="#45413c"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.91 6.67h24.18a3.3 3.3 0 0 1 3.3 3.3v6h0H8.61h0V10a3.3 3.3 0 0 1 3.3-3.33"
        strokeWidth="1"
      />
      <path
        fill="#e8f4fa"
        d="M15.2 9.42a1.11 1.11 0 0 1-1.1-1.1V5a1.1 1.1 0 0 1 1.1-1.1A1.1 1.1 0 0 1 16.3 5v3.3a1.1 1.1 0 0 1-1.1 1.12m8.8 0a1.1 1.1 0 0 1-1.1-1.1V5A1.1 1.1 0 0 1 24 3.92A1.1 1.1 0 0 1 25.1 5v3.3A1.1 1.1 0 0 1 24 9.42m8.8 0a1.1 1.1 0 0 1-1.1-1.1V5a1.1 1.1 0 0 1 1.1-1.1A1.1 1.1 0 0 1 33.9 5v3.3a1.11 1.11 0 0 1-1.1 1.12"
      />
      <path
        fill="#fff"
        d="M15.2 3.92A1.1 1.1 0 0 0 14.1 5v1.67a1.1 1.1 0 0 1 2.2 0V5a1.1 1.1 0 0 0-1.1-1.08m8.8 0A1.1 1.1 0 0 0 22.9 5v1.67a1.1 1.1 0 0 1 2.2 0V5A1.1 1.1 0 0 0 24 3.92m8.8 0A1.1 1.1 0 0 0 31.7 5v1.67a1.1 1.1 0 0 1 2.2 0V5a1.1 1.1 0 0 0-1.1-1.08"
      />
      <path
        fill="none"
        stroke="#45413c"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.2 9.42a1.11 1.11 0 0 1-1.1-1.1V5a1.1 1.1 0 0 1 1.1-1.1h0A1.1 1.1 0 0 1 16.3 5v3.3a1.1 1.1 0 0 1-1.1 1.12m8.8 0a1.1 1.1 0 0 1-1.1-1.1V5A1.1 1.1 0 0 1 24 3.92h0A1.1 1.1 0 0 1 25.1 5v3.3A1.1 1.1 0 0 1 24 9.42m8.8 0a1.1 1.1 0 0 1-1.1-1.1V5a1.1 1.1 0 0 1 1.1-1.1h0A1.1 1.1 0 0 1 33.9 5v3.3a1.11 1.11 0 0 1-1.1 1.12"
        strokeWidth="1"
      />
      <path
        fill="#45413c"
        d="M17.94 32.21v-9h-1.06a1.12 1.12 0 0 1-.92-.37a1.33 1.33 0 0 1-.31-.88A1.28 1.28 0 0 1 16 21a1.15 1.15 0 0 1 .9-.37h2.56a1.17 1.17 0 0 1 .89.35a1.36 1.36 0 0 1 .32.93v10.3a1.4 1.4 0 0 1-.38 1a1.34 1.34 0 0 1-1 .36a1.32 1.32 0 0 1-1-.37a1.36 1.36 0 0 1-.35-.99m5.66-.51l4.51-8.54h-4.63a1.3 1.3 0 0 1-1-.36a1.25 1.25 0 0 1 1-2.13H30a1.13 1.13 0 0 1 1 .43a1.44 1.44 0 0 1 .33.87a1.3 1.3 0 0 1-.11.52a7 7 0 0 1-.3.67l-4.48 9.09a6 6 0 0 1-.47.85a1.2 1.2 0 0 1-.41.39a1.67 1.67 0 0 1-1.72-.29a1.22 1.22 0 0 1-.41-.86a1.4 1.4 0 0 1 .17-.64"
      />
    </svg>
  )
}

export default Calendar
